import { Link } from 'react-router-dom'
import { CaptacaoContextBanner } from '@/components/Dashboard/CaptacaoContextBanner'
import { CaptacaoKpiGrid } from '@/components/Dashboard/CaptacaoKpiGrid'
import { CaptacaoStatusChart } from '@/components/Dashboard/CaptacaoStatusChart'
import { CaptacaoTrendChart } from '@/components/Dashboard/CaptacaoTrendChart'
import {
  shouldShowCaptacaoContextBanner,
  type CaptacaoTabView,
} from '@/components/Dashboard/captacaoTab.utils'

type Props = {
  view: CaptacaoTabView
  valuesVisible?: boolean
}

export function CaptacaoTab({ view, valuesVisible = false }: Props) {
  return (
    <div className='space-y-6'>
      <div className='flex flex-wrap items-end justify-between gap-3'>
        <p className='text-sm text-text-muted'>
          Performance de captação na carteira closer — entradas, qualificação e conversão para
          negócio.
        </p>
        <Link
          to='/closer-leads'
          className='rounded-full border border-[var(--border)] px-3 py-1 text-xs font-semibold text-text-secondary hover:bg-[var(--bg-dark)]/20'
        >
          Abrir carteira closer
        </Link>
      </div>

      {shouldShowCaptacaoContextBanner(view) ? (
        <CaptacaoContextBanner view={view} valuesVisible={valuesVisible} />
      ) : null}

      <CaptacaoKpiGrid view={view} valuesVisible={valuesVisible} />

      <div className='grid grid-cols-1 gap-4 xl:grid-cols-3'>
        <div className='xl:col-span-2'>
          <CaptacaoTrendChart view={view} valuesVisible={valuesVisible} />
        </div>
        <CaptacaoStatusChart view={view} valuesVisible={valuesVisible} />
      </div>
    </div>
  )
}
